// @flow
import { SET_SIDEBAR_VISIBLE, SET_WELCOME_PAGE_LISTS_DEFAULT_PAGE, IS_LOGIN_PENDING, IS_LOGIN_SUCCESS, IS_LOGIN_FAILURE, } from './actionTypes';
// @ts-ignore
import apiService from "../../services/api-service";
// @ts-ignore
import { jitsiLocalStorage } from "@jitsi/js-utils";
// @ts-ignore
import { getSanitizedString } from '../../utilities/validation';
/**
 * Sets the visibility of {@link WelcomePageSideBar}.
 *
 * @param {boolean} visible - If the {@code WelcomePageSideBar} is to be made
 * visible, {@code true}; otherwise, {@code false}.
 * @returns {{
 *     type: SET_SIDEBAR_VISIBLE,
 *     visible: boolean
 * }}
 */
export function setSideBarVisible(visible) {
    return {
        type: SET_SIDEBAR_VISIBLE,
        visible
    };
}
/**
 * Sets the default page index of {@link WelcomePageLists}.
 *
 * @param {number} pageIndex - The index of the default page.
 * @returns {{
 *     type: SET_WELCOME_PAGE_LISTS_DEFAULT_PAGE,
 *     pageIndex: number
 * }}
 */
export function setWelcomePageListsDefaultPage(pageIndex) {
    return {
        type: SET_WELCOME_PAGE_LISTS_DEFAULT_PAGE,
        pageIndex
    };
}
export function isLoginPending() {
    return {
        type: IS_LOGIN_PENDING,
        isLoginPending: true,
    };
}
export function isLoginSuccess(jwt) {
    return {
        type: IS_LOGIN_SUCCESS,
        isLoginSuccess: true,
        jwt,
    };
}
export function isLoginFailure(errorMessage) {
    return {
        type: IS_LOGIN_FAILURE,
        isLoginFailure: true,
        errorMessage
    };
}
export const doLogin = (requestBody) => async (dispatch) => {
    dispatch(isLoginPending());
    let response = await apiService.doLogin(requestBody);
    let jwt = response && response.data && response.data.jwt;
    let user_token = response && response.data && response.data.user_token;
    if (user_token) {
        jitsiLocalStorage.setItem("user_token", user_token);
        jitsiLocalStorage.setItem("username", requestBody.username);
        dispatch(isLoginSuccess(jwt));
    }
    else {
        let errorMessage = response && response.data && response.data.message;
        alert(errorMessage);
        jitsiLocalStorage.removeItem("user_token");
        jitsiLocalStorage.removeItem("username");
    }
    if (requestBody.room_name && jwt) {
        window.location.href = requestBody.redirectURL + "/" + getSanitizedString(requestBody.room_name) + "?jwt=" + jwt;
    }
    // apiService.doLogin(requestBody).then(
    //     (response) => {
    //         console.log("resposne from API::", response);
    //         let jwt = response && response.data && response.data.jwt;
    //         if (jwt) {
    //             alert(jwt);
    //             window.location.href = "https://blueskymeet.com/"+requestBody.room_name+"?jwt="+jwt;
    //             jitsiLocalStorage.setItem("jwt", jwt);
    //             dispatch(isLoginSuccess(jwt));
    //         } else {
    //             jitsiLocalStorage.removeItem("jwt");
    //             let errorMessage =
    //                 response && response.data && response.data.message;
    //             dispatch(isLoginFailure(errorMessage));
    //         }
    //     },
    //     (error) => {
    //         jitsiLocalStorage.removeItem("jwt");
    //         console.log("error from API::", error.response);
    //         dispatch(isLoginFailure());
    //     }
    // );
};
export const doSSOLogin = (requestBody) => async (dispatch) => {
    dispatch(isLoginPending());
    let response = await apiService.doSSOLogin(requestBody);
    let jwt = response && response.data && response.data.jwt;
    let user_token = response && response.data && response.data.user_token;
    let username = response && response.data && response.data.data && response.data.data.username;
    if (user_token) {
        jitsiLocalStorage.setItem("user_token", user_token);
        jitsiLocalStorage.setItem("sso_token", requestBody.sso_token);
        jitsiLocalStorage.setItem("username", username);
        dispatch(isLoginSuccess(jwt));
    }
    else {
        let errorMessage = response && response.data && response.data.message;
        alert(errorMessage);
        jitsiLocalStorage.removeItem("user_token");
        jitsiLocalStorage.removeItem("sso_token");
        jitsiLocalStorage.removeItem("username");
    }
    if (requestBody.room_name && jwt) {
        jitsiLocalStorage.removeItem("bbbssoroomname");
        window.location.href = requestBody.ssoConfRedirect_uri + "/" + getSanitizedString(requestBody.room_name) + "?jwt=" + jwt + "#config.prejoinPageEnabled=false";
    }
};
export async function getJwt(requestBody) {
    let response = await apiService.getJwt(requestBody);
    let jwt = response && response.data && response.data.jwt;
    if (jwt) {
        window.location.href = requestBody.ssoConfRedirect_uri + "/" + getSanitizedString(requestBody.room_name) + "?jwt=" + jwt;
    }
    else {
        let errorMessage = response && response.data && response.data.message;
        alert(errorMessage);
    }
}
export async function forgotPassword(username) {
    let response = await apiService.forgotPassword(username);
    let message = response && response.data && response.data.message;
    alert(message);
}
